module.exports = __webpack_public_path__ + "img/jpt_null.93ac9e97.png";